import ColorfulRate from './colorful-rate';
export default ColorfulRate;
